import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SmsMain_Rep } from '../../../../classes/Automation/sms_mainreport';
import { SmsDetail_Rep } from '../../../../classes/Automation/sms_detailreport';
import { BalanceGetting } from '../../../../classes/Automation/balance';
import { User } from '../../../../classes/Automation/UserApp';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { RepDates } from '../../../../classes/Automation/RepDates';

@Injectable()
export class HttpService2 {
    constructor(private http: HttpClient) { }


    /*     postData4Report(rep: SmsMain_Rep){ 
            const body = {enable:Setting.enable ,daysbefore:Setting.daysbefore,
                apTime:Setting.apTime,txtmessage:Setting.txtmessage,attname:Setting.attname,attlink:Setting.attlink}; 
            return this.http.post(environment.urlserv+'/Home/PostSMSAppointment4Send',body);  
        } 
    
     */

    /*   getFactorial(num: number){ 
            return this.http.get('http://localhost:63989/Home/GetFactorial?number=' + num); 
        }  */


    getReportMain(user: User, repdates: RepDates) {
        const body = { useremail: user.useremail, smsdatefrom: repdates.smsdatefrom, smsdateto: repdates.smsdateto };
        return this.http.post(environment.urlserv + '/Home/GetDataReportMain', body);
    }


    getReportDetail(user: User, repdates: RepDates) {
        const body = { useremail: user.useremail, smsdatefrom: repdates.smsdatefrom, smsdateto: repdates.smsdateto };
        return this.http.post(environment.urlserv + '/Home/GetDataReportDetail', body);
    }

    /* getReportMain(user: User,repdates:RepDates) {
        return this.http.get<any>(environment.urlserv+'/GetDataReportMain/?user='+user+'&repdates'+repdates) 
        .toPromise()
        .then(res => <SmsMain_Rep[]>res.data)
        .then(data => { return data; });
    }
     */
    /* getReportDetail(daterep:string) {
        return this.http.get<any>(environment.urlserv+'/GetDataReportDetail/DateRep='+daterep) 
        .toPromise()
        .then(res => <SmsMain_Rep[]>res.data)
        .then(data => { return data; });
    }
     */
    // getReportMainMobile() {
    //     return this.http.get<any>(environment.urlserv+'/Home/GetDataReportMain') 
    //     .toPromise()
    //     .then(res => <SmsMain_Rep[]>res.data)
    //     .then(data => { return data; });
    // }

    getReportMainMobile(user: User, repdates: RepDates) {
        const body = { useremail: user.useremail, smsdatefrom: repdates.smsdatefrom, smsdateto: repdates.smsdateto };
        return this.http.post(environment.urlserv + '/Home/GetDataReportMain', body);
    }

    getReportDetailMobile(daterep: string) {
        return this.http.get<any>(environment.urlserv + '/GetDataReportDetail/DateRep=' + daterep)
            .toPromise()
            .then(res => <SmsMain_Rep[]>res.data)
            .then(data => { return data; });
    }




    getReportTMP() {
        return this.http.get<any>('assets/tmp_data.json')
            .toPromise()
            .then(res => <SmsMain_Rep[]>res.data)
            .then(data => { return data; });
    }

    getReportTMPDetails() {
        return this.http.get<any>('assets/tmp_data_details.json')
            .toPromise()
            .then(res => <SmsDetail_Rep[]>res.data)
            .then(data => { return data; });
    }

    getReportTMPMobile() {
        return this.http.get<any>('assets/tmp_data.json')
            .toPromise()
            .then(res => <SmsMain_Rep[]>res.data)
            .then(data => { return data; });
    }

    getReportTMPDetailsMobile() {
        return this.http.get<any>('assets/tmp_data_details.json')
            .toPromise()
            .then(res => <SmsDetail_Rep[]>res.data)
            .then(data => { return data; });
    }


    /* getDetails() : Observable<SmsDetail_Rep[]> {
        return this.http.get('assets/tmp_data_details.json').pipe(map(data=>{
            let repdetList = data["data"];
            return repdetList.map(function(SmsDetail_Rep:any) {
                return {name: SmsDetail_Rep.name, status: SmsDetail_Rep.status,phone:SmsDetail_Rep.phone,
                 id:SmsDetail_Rep.id,message:SmsDetail_Rep.message,smsdate:SmsDetail_Rep.smsdate,reason:SmsDetail_Rep.reason};
              });
        }));
    } */



}